// Barra de progresso no topo durante a navegacao entre paginas (renderizada pelo TopProgressCmp).
// So conta requests iniciados enquanto ha uma navegacao ativa, para ignorar pollings em segundo plano.
import Vue from 'vue';

const SHOW_DELAY = 120;
const TRICKLE_INTERVAL = 250;
const CHAINED_REQUEST_GRACE = 200;
const NO_REQUEST_GRACE = 300;
const SAFETY_TIMEOUT = 15000;
const COMPLETE_TIME = 200;
const FADE_TIME = 250;
const START_PROGRESS = 0.08;
const MAX_TRICKLE_PROGRESS = 0.94;

export const topProgressState = Vue.observable({
  progress: 0,
  visible: false,
});

let active = false;
let settled = false;
let pending = 0;
let showTimer: number | undefined;
let trickleTimer: number | undefined;
let finishTimer: number | undefined;
let safetyTimer: number | undefined;
let hideTimer: number | undefined;

function clearTimers(): void {
  window.clearTimeout(showTimer);
  window.clearInterval(trickleTimer);
  window.clearTimeout(finishTimer);
  window.clearTimeout(safetyTimer);
  window.clearTimeout(hideTimer);
}

function trickle(): void {
  const p = topProgressState.progress;
  const inc = p < 0.2 ? 0.1 : p < 0.5 ? 0.04 : p < 0.8 ? 0.02 : 0.005;

  topProgressState.progress = Math.min(p + inc, MAX_TRICKLE_PROGRESS);
}

function show(): void {
  topProgressState.progress = START_PROGRESS;
  topProgressState.visible = true;
  trickleTimer = window.setInterval(trickle, TRICKLE_INTERVAL);
}

function scheduleFinish(delay: number): void {
  window.clearTimeout(finishTimer);
  finishTimer = window.setTimeout(finish, delay);
}

function finish(): void {
  const wasVisible = topProgressState.visible;

  active = false;
  settled = false;
  pending = 0;
  clearTimers();

  if (!wasVisible) {
    topProgressState.progress = 0;
    return;
  }

  topProgressState.progress = 1;

  hideTimer = window.setTimeout(() => {
    topProgressState.visible = false;

    hideTimer = window.setTimeout(() => {
      topProgressState.progress = 0;
    }, FADE_TIME);
  }, COMPLETE_TIME);
}

export function startTopProgress(): void {
  clearTimers();

  active = true;
  settled = false;
  pending = 0;

  if (topProgressState.visible) {
    // navegacao nova com a barra ainda na tela: continua de onde esta
    trickleTimer = window.setInterval(trickle, TRICKLE_INTERVAL);
  } else {
    showTimer = window.setTimeout(show, SHOW_DELAY);
  }

  safetyTimer = window.setTimeout(finish, SAFETY_TIMEOUT);
}

// chamado no afterEach: a partir daqui, termina quando os requests da pagina acabarem
export function settleTopProgress(): void {
  if (!active) {
    return;
  }

  settled = true;

  if (!pending) {
    scheduleFinish(NO_REQUEST_GRACE);
  }
}

export function trackRequestStart(): boolean {
  if (!active) {
    return false;
  }

  pending++;
  window.clearTimeout(finishTimer);
  return true;
}

export function trackRequestEnd(): void {
  if (!active) {
    return;
  }

  pending = Math.max(0, pending - 1);

  if (settled && !pending) {
    scheduleFinish(CHAINED_REQUEST_GRACE);
  }
}
